var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.2,9.6l8.6,4.8c0.7,0.4,1.4,0.6,2.2,0.6s1.5-0.2,2.2-0.6l8.6-4.8C23.5,9.1,24,8.4,24,7.5s-0.5-1.6-1.2-2.1 l-8.6-4.8c-1.4-0.8-3.1-0.8-4.4,0L1.2,5.4C0.5,5.9,0,6.6,0,7.5S0.5,9.1,1.2,9.6z M13.2,12.7c-0.7,0.4-1.7,0.4-2.4,0l-3-1.7l5.5-3.1 l4.2,2.4L13.2,12.7L13.2,12.7z M22,7.5c0,0.1,0,0.2-0.2,0.3l-2.3,1.3l-4.2-2.4l2.9-1.6l3.6,2C22,7.3,22,7.4,22,7.5L22,7.5z  M10.8,2.3L10.8,2.3C11.1,2.1,11.6,2,12,2s0.9,0.1,1.2,0.3L16.1,4l-5.6,3.1L6.5,4.8L10.8,2.3L10.8,2.3z M2.2,7.2l2.2-1.2l4.1,2.3 L5.7,9.8l-3.5-2C2,7.7,2,7.6,2,7.5S2,7.3,2.2,7.2L2.2,7.2z M23.9,12.2c0.3,0.5,0.1,1.1-0.4,1.4L14.2,19c-0.7,0.4-1.5,0.6-2.2,0.6 s-1.5-0.2-2.2-0.6l-9.3-5.2c-0.5-0.3-0.7-0.9-0.4-1.4S1,11.7,1.5,12l9.3,5.2c0.7,0.4,1.7,0.4,2.5,0l9.3-5.4 C23,11.5,23.6,11.7,23.9,12.2L23.9,12.2z M23.9,16.6c0.3,0.5,0.1,1.1-0.4,1.4l-9.3,5.4C13.5,23.8,12.8,24,12,24s-1.5-0.2-2.2-0.6 l-9.3-5.2c-0.5-0.3-0.7-0.9-0.4-1.4c0.3-0.5,0.9-0.7,1.4-0.4l9.3,5.2c0.7,0.4,1.7,0.4,2.5,0l9.3-5.4C23,16,23.6,16.1,23.9,16.6 L23.9,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.44ec6c63429b6c27c4eee786015f8385.svg";
export { ForwardRef as ReactComponent };